import * as countryCodesApi from '../services/api/countryCodes';
import * as sessionApi from "../services/api/session";

export const UPDATE_COUNTRY_CODES = 'UPDATE_COUNTRY_CODES';
export const SET_COUNTRY_BY_IP = 'SET_COUNTRY_BY_IP';

export function getAll(){
    return dispatch => {
        const success = response => dispatch(updateCountryCodes(response.payload));
        const fail = errors => console.log(errors);

        return countryCodesApi
            .getAll()
            .then(success, fail);
    }
}

function updateCountryCodes(countryCodes){
    return {
        type: UPDATE_COUNTRY_CODES,
        countryCodes
    }
}

export function getCountryByIp(){
    return dispatch => {
        return sessionApi
            .getCountryCode()
            .then((res) => {
                dispatch(setCountry(res.payload));
            });
    }
}

function setCountry(country){
    return {
        type: SET_COUNTRY_BY_IP,
        country
    }
}